export default __webpack_public_path__ + "static/media/dcent-wallet.73bd7082.png";